import { useTanstackNotificationsUnreadFetchFn } from '@/components/Functional/hooks-core/useTanstackFetchFn'
import { useQuery } from '@tanstack/react-query'

type UseNotificationBadgeResult = {
  /** 未読通知が存在するか。true の場合はヘッダーに点バッジを表示する */
  hasUnread: boolean
}

/**
 * ヘッダー通知バッジの未読状態を返すフック。
 * - 認証済み時: GET /api/v2/notifications/unread を呼び出し、hasUnread を返す
 * - 未認証時: hasUnread: false を返す（バッジ非表示）
 */
export const useNotificationBadge = (isAuthenticated: boolean): UseNotificationBadgeResult => {
  const fetchFn = useTanstackNotificationsUnreadFetchFn()
  const { data } = useQuery({
    ...fetchFn,
    enabled: isAuthenticated,
  })

  return { hasUnread: data?.notificationsUnread?.hasUnread ?? false }
}
